import { serverTimestamp } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions, httpsCallable } from 'firebase/functions'
import db from '../db/db'

export interface SubmitSupportTicketInput {
  subject: string
  message: string
}

export async function submitSupportTicket(
  input: SubmitSupportTicketInput
): Promise<string> {
  const auth = getAuth()
  const currentUser = auth.currentUser

  if (!currentUser) {
    throw new Error('Please sign in to submit a support ticket')
  }

  const result = await db.addItem('supportTickets', {
    userId: currentUser.uid,
    subject: input.subject,
    message: input.message,
    status: 'open',
    createdAt: serverTimestamp(),
    resolvedAt: null
  })

  // Fire-and-forget: notify support email via cloud function
  const functions = getFunctions()
  const sendSupportEmail = httpsCallable(functions, 'onSupportTicketCreated')
  sendSupportEmail({
    ticketId: result.id,
    subject: input.subject,
    message: input.message,
    userEmail: currentUser.email
  }).catch(() => {
    // Email notification is best-effort
  })

  return result.id
}
